import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText
} from 'reactstrap';
import { inject, observer } from "mobx-react";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
import { isEqual, isEmpty } from 'lodash';
import v from "voca";
import moment from "moment";
import Select from 'react-select';
import { IMAGE } from "common-import/constants";
import { Loading } from "common-import/custom";
import MembershipList from './Membership';

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const propertyUser = [
  "name",
  "firstName",
  "lastName",
  "phone",
  "about",
  "address",
  "country",
  "city",
  "district",
  "language",
  "type",
];

@inject("userStore", "masterStore") @observer
export default class UserDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: {},
      current: {},
      readMore: false,
      enableEdit: false,
      isSaving: false,
      isLoading: true,
      avatar: {
        file: null,
        url: '',
      },
      cover: {
        file: null,
        url: '',
      },
      visibleList: "contractor",
    };
    this.handleSelectTypes = this.handleSelectTypes.bind(this);
    this.readMoreClicked = this.readMoreClicked.bind(this);
    this.handleEnableEdit = this.handleEnableEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.changeAvatar = this.changeAvatar.bind(this);
    this.changeCover = this.changeCover.bind(this);
  }

  async componentDidMount() {
    this.setState({isLoading: true});
    await this.props.userStore.onReady();
    const { userStore, match } = this.props;
    const userId = match.params.id;
    const res = await userStore.getUserDetailById(userId);
    this.setState({isLoading: false});
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({
      user: VarHelper.cloneDeep(res.data),
      current: VarHelper.cloneDeep(res.data)
    });
  }

  readMoreClicked = (e) => {
    e.preventDefault();
    this.setState({ readMore: !this.state.readMore })
  };

  handleEnableEdit = (e) => {
    e.preventDefault();
    this.setState({ enableEdit: true });
  };

  handleSelectTypes = (selectedOption) => {
    let type = [];
    selectedOption.map((item) => {
      type = [...type, item.value];
    });
    this.setState({
      current: {...this.state.current, type}
    })
  };

  changeAvatar = (e) => {
    !!e && e.preventDefault();
    const { current } = this.state;
    this.setState({
      avatar: {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0])
      },
      current: {...current, avatar: URL.createObjectURL(e.target.files[0])}
    })
  };

  changeCover = (e) => {
    !!e && e.preventDefault();
    const { current } = this.state;
    this.setState({
      cover: {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0])
      },
      current: {...current, cover: URL.createObjectURL(e.target.files[0])}
    })
  };

  cancelEdit = (e) => {
    !!e && e.preventDefault();
    const { user, current } = this.state;
    if (!isEqual(current, user)) {
      if (!window.confirm('Are you sure want to cancel the changes?')) {
        return;
      }
      this.setState({
        current: VarHelper.cloneDeep(user),
      });
    }
    this.setState({ enableEdit: false });
  };

  renderFormEdit = (user) => {
    const {
      country,
      language,
      toSelectData,
    } = this.props.masterStore;

    const propMaster = {
      country,
      language,
    };

    const renderOptions = (prop) => {
      const arr = [{id: '', label: '', value: ''}, ...toSelectData(propMaster[prop])];
      return arr.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    const types = [
      { label: 'ProjectOwner', value: 'ProjectOwner' },
      { label: 'Contractor', value: 'Contractor' },
      { label: 'Supplier', value: 'Supplier' },
    ];

    const getSelected = () => {
      if (user.hasOwnProperty('type') && user.type.length) {
        return user.type.map(item => {
          return { label: item, value: item };
        });
      }
      return [];
    };

    if (user) {
      return (
        <form className="block-content">
          <h4 className="block-content__title">
            <i className="fa fa-pencil" aria-hidden="true"> </i>
            Edit user information
          </h4>
          <div className="row">
            {
              propertyUser.map((property, index) => {
                let element;
                if (property === "about") {
                  element = <div className="position-relative form-group">
                    <Label htmlFor={"nf-" + property}>{v.capitalize(property)}:</Label>
                    <textarea
                      className="form-control"
                      id={"nf-" + property}
                      name={"nf-" + property}
                      value={this.state.current[property] || ''}
                      onChange={e => this.setState({
                        current: { ...this.state.current, [property]: e.target.value }
                      })}
                      placeholder={v.capitalize(property)}
                    />
                  </div>
                } else if (property === "type") {
                  element = <div className="position-relative form-group">
                      <Label htmlFor={"nf-" + property}>{v.capitalize(property)}:</Label>
                      <Select isMulti
                        value={getSelected()}
                        onChange={this.handleSelectTypes}
                        options={types}
                      />
                    </div>
                } else if (["country", "language"].includes(property)) {
                  element = <div className="position-relative form-group">
                    <Label htmlFor={"nf-" + property}>{v.capitalize(property)}</Label>
                    <select
                      id={"nf-" + property}
                      name={"nf-" + property}
                      className="form-control"
                      value={this.state.current[property]}
                      onChange={e => this.setState({
                        current: { ...this.state.current, [property]: e.target.value }
                      })}
                      placeholder={v.capitalize(property)}
                    >
                      {renderOptions(property)}
                    </select>
                  </div>
                } else {
                  element = <div className="position-relative form-group">
                    <Label htmlFor={"nf-" + property}>{v.capitalize(property)}:</Label>
                    <Input
                      type="text"
                      id={"nf-" + property}
                      name={"nf-" + property}
                      value={this.state.current[property] === null ? '' : this.state.current[property]}
                      onChange={e => this.setState({
                        current: { ...this.state.current, [property]: e.target.value }
                      })}
                      placeholder={v.capitalize(property)}
                    />
                  </div>
                }

                return (
                  <div className="col-md-6" key={"property" + index}>
                    {element}
                  </div>
                );
              })
            }
          </div>
        </form>
      )
    }
  };

  renderUserDetail = (user) => {
    if (user) {
      const { readMore, enableEdit } = this.state;

      const renderTypes = (items) => {
        return items.map((item, index) => {
          if (index === items.length - 1) {
            return item;
          }
          return item + ' / ';
        })
      };

      const styleNone = {
        display: enableEdit ? 'inline-block' : 'none',
      };

      let { about } = user;
      about = !!about ? about : '';

      return (
        <div className="user-profile">
          <div className="user-profile__image bg-image"
               style={{backgroundImage:`url(${VarHelper.img(user.avatar) || defaultImage})`}}>
            <label htmlFor="tu-edit-avatar" style={styleNone} className="btn btn-danger icon-edit">
              <i className="fa fa-pencil" aria-hidden="true"> </i>
            </label>
            <input onChange={this.changeAvatar} style={{ display: 'none' }} type="file" id="tu-edit-avatar" name="avatar"/>
          </div>
          <div className="user-profile__cover" style={{backgroundImage: `url(${VarHelper.img(user.cover) || IMAGE})`}}>
            <label htmlFor="tu-edit-cover" style={styleNone} className="btn btn-danger icon-edit">
              <i className="fa fa-pencil" aria-hidden="true"> </i>
            </label>
            <input onChange={this.changeCover} style={{ display: 'none' }} type="file" id="tu-edit-cover" name="cover"/>
          </div>
          <div className="user-profile__body">
            <p className="user-profile__role">{renderTypes(user.type || [])}</p>
            <h5 className="user-profile__name">{user.name}</h5>
            <div className="user-profile__about">
              { VarHelper.readMoreString(about, readMore, 200) }
              <a style={{display: about.length > 200 ? 'inline' : 'none'}}
                 onClick={e => this.readMoreClicked(e)}
                 href="#"
              >
                Show {readMore ? 'less' : 'more'}
              </a>
            </div>
            <div className="user-profile__more">
              <p>Supper Admin: {user.isSuperAdmin ? 'Yes': 'No'}</p>
              <p>Type of Account: {user.accountStatus}</p>
              <p>Active: {user.actived ? 'Yes': 'No'}</p>
              <p>Created at: {moment(user.createdAt).format('LL')}</p>
            </div>
          </div>
        </div>
      )
    }
  };

  renderNotifySetting = () => {
    let { current, enableEdit } = this.state;
    let { notifySetting } = current;
    if (!notifySetting) {
      notifySetting = {
        trackingProject: false,
        submitBid: false,
        evaluateProfile: false,
        shareProject: false,
        sendMessage: false,
        projectExpire: false,
        confirmInvited: false,
        houselinkSendMessage: false,
        haveSuitableSubscription: false
      };
    }
    return (
      <div className="block-content" style={{marginTop:enableEdit?'0':'56px'}}>
        <h3 className="block-content__title">Notify settings</h3>
        {
          Object.entries(notifySetting).map(([key, value]) => {
            if (enableEdit) {
              return <div className="custom-control custom-checkbox" key={key}>
                <input checked={value} type="checkbox" className="custom-control-input" id={'notify-' + key}
                       onChange={e => this.setState({
                         current: { ...current, notifySetting: {...notifySetting, [key]: e.target.checked} }
                       })}
                />
                <label className="custom-control-label" htmlFor={'notify-' + key}>{v.capitalize(key)}</label>
              </div>
            } else {
              return <div key={key} className="raw-group">
                <span className="key">{ v.capitalize(key) }</span>
                <span className="string"> </span>
                <span className="value">{ value ? 'Yes':'No' }</span>
              </div>
            }
          })
        }
      </div>
    );
  };

  renderBlockUser = () => {
    const { userStore, match } = this.props;
    const { actived } = this.state.current;

    const handleBlock = async () => {
      const res = userStore.blockUser({id: match.params.id});
      if (!!res.error) {
        return window.toast.error('Failure: ', JSON.stringify(res.error));
      }
      this.setState({
        current: {...this.state.current, actived: false},
        user: {...this.state.user, actived: false}
      });
      return window.toast.info('BLOCKED');
    };

    const handleUnBlock = async () => {
      const res = userStore.unBlockUser({id: match.params.id});
      if (!!res.error) {
        return window.toast.error(JSON.stringify(res.error));
      }
      this.setState({
        current: {...this.state.current, actived: true},
        user: {...this.state.user, actived: true}
      });
      return window.toast.info('UNBLOCKED');
    };

    if (actived) {
      return <button className="btn btn-sm btn-danger" onClick={handleBlock}>BLOCK</button>
    }
    return <button className="btn btn-sm btn-primary" onClick={handleUnBlock}>UNBLOCK</button>
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeArray: ["type"],
      typeObject: ["notifySetting", "membershipInfo"],
      typeString: ["id", "name", "lastName", "firstName", "address", "city", "country", "district", "phone", "avatar", "cover", "language", "about"],
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  saveChanges = async () => {
    const { userStore } = this.props;
    const { current, avatar, cover } = this.state;

    this.setState({ isSaving: true });

    if (avatar.file !== null) {
      const avatarURL = await Request.upload(avatar.file);
      this.setState({ current: {...current, avatar: avatarURL} })
    }
    if (cover.file !== null) {
      const coverURL = await Request.upload(cover.file);
      this.setState({ current: {...current, cover: coverURL} });
    }

    const payload = this.formatPayload(this.state.current);
    const res = await userStore.update(payload);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error(JSON.stringify(res.error));
    }

    this.setState({
      user: VarHelper.cloneDeep(res.data),
      current: VarHelper.cloneDeep(res.data),
    });

    return window.toast.info('Updated successfully.');
  };

  handleSelectMembership = (e, index) => {
    !!e && e.preventDefault();
    let { visibleList, current } = this.state;
    const pkg = MembershipList[visibleList];
    let membershipInfo = current.membershipInfo || {contractor: [], projectOwner: [], supplier: []};
    const item = membershipInfo[visibleList].find(itm => itm.packageName === pkg["packages"][index].packageName);
    if (!!pkg["canHaveMultiplePackage"]) {
      if (!!item) {
        membershipInfo[visibleList] = membershipInfo[visibleList].filter(itm => itm.packageName !== pkg["packages"][index].packageName);
      } else {
        const { packageName, packagePrice } = pkg["packages"][index];
        membershipInfo[visibleList] = [...membershipInfo[visibleList], {packageName, packagePrice}];
      }
    } else {
      if (!!item) {
        membershipInfo[visibleList] = [];
      } else {
        const { packageName, packagePrice } = pkg["packages"][index];
        membershipInfo[visibleList] = [{packageName, packagePrice}];
      }
    }
    current["membershipInfo"] = membershipInfo;
    this.setState({current});
  };

  renderMembership = () => {
    const { current, user, visibleList, isSaving } = this.state;
    let membershipInfo = {};
    !!current.membershipInfo ? membershipInfo = current.membershipInfo : null;
    const list = MembershipList[visibleList]["packages"];

    const renderDetail = () => {
      return (
        <div className="row">
          {
            list.map((item, index) => {
              return (
                <div key={item.packageName+index} className={`col-md-${12/list.length}`}>
                  <div className="card text-center">
                    <div className="card-header">
                      <h5 style={{width:'100%'}}>{item.packageName}</h5>
                    </div>
                    <div className="card-body">
                      <h4>
                        <span className="text-success">{item.packagePrice}</span>
                        <span style={{fontSize: '1rem'}}>/{item.per}</span>
                      </h4>
                    </div>
                    <div className="card-footer">
                      {
                        (() => {
                          let applied = false;
                          if (!membershipInfo[visibleList]) return (<button className="btn btn-primary btn-block" onClick={e => this.handleSelectMembership(e, index)}>Select</button>);
                          const lst = membershipInfo[visibleList].filter(itm => item.packageName === itm.packageName);
                          !!lst.length ? applied = true : null;
                          if (!!applied) {
                            return (<button className="btn btn-outline-success btn-block" onClick={e => this.handleSelectMembership(e, index)}>Applied</button>);
                          }
                          return (<button className="btn btn-primary btn-block" onClick={e => this.handleSelectMembership(e, index)}>Select</button>);
                        })()
                      }
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      )
    };

    return (
      <div className="block-content" style={{marginTop:'32px'}}>
        <div className="btn-group text-center" style={{margin:'16px 0 40px', display:'block'}}>
          <button onClick={() => this.setState({visibleList: 'contractor'})} className={visibleList === 'contractor' ? 'btn btn-primary':'btn btn-outline-primary'}>Contractor</button>
          <button onClick={() => this.setState({visibleList: 'projectOwner'})} className={visibleList === 'projectOwner' ? 'btn btn-primary':'btn btn-outline-primary'}>Project Owner</button>
          <button onClick={() => this.setState({visibleList: 'supplier'})} className={visibleList === 'supplier' ? 'btn btn-primary':'btn btn-outline-primary'}>Supplier</button>
        </div>
        {renderDetail()}
        {
          isEqual(user.membershipInfo, current.membershipInfo) ?
            null
            :
            <div className="text-center" style={{marginTop:'24px'}}>
              <button className="btn btn-sm btn-danger" onClick={e => this.saveChanges(e)} disabled={isSaving}>
                <i className="fa fa-dot-circle-o"> </i> {isSaving ? 'Saving...':'Save'}
              </button>
              <button className="btn btn-sm btn-default" onClick={e => this.cancelEdit(e)}><i className="fa fa-ban"> </i> Cancel</button>
            </div>
        }
      </div>
    )
  };

  render() {
    let { current, enableEdit, isSaving, isLoading } = this.state;
    let content;

    if (isLoading) return (<Loading> </Loading>);

    if (enableEdit) {
      content = <Card>
        <CardHeader>
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i>User details: <strong>{current.name} ({current.id})</strong>
          </div>
        </CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-md-6">
              {this.renderFormEdit(current)}
              {this.renderNotifySetting()}
            </div>
            <div className="col-md-6">
              {this.renderUserDetail(current)}
            </div>
          </div>
        </CardBody>
        <CardFooter>
          <div className="button-group">
            <Button size="sm" color="primary" disabled={isSaving} onClick={this.saveChanges}>
              <i className="fa fa-dot-circle-o"> </i> { isSaving ? 'Saving...' : 'Save' }
            </Button>
            <Button size="sm" color="danger" onClick={this.cancelEdit}>
              <i className="fa fa-ban"> </i> Cancel
            </Button>
          </div>
        </CardFooter>
      </Card>
    } else {
      content = <Card>
        <CardHeader>
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i> User details: <strong>{current.name} ({current.id})</strong>
            <div style={{display:'inline-block',padding:'0 16px'}}>
              {this.renderBlockUser()}
            </div>
          </div>
          <div className="card-header-right">
            <button onClick={this.handleEnableEdit}
                    className="btn btn-sm btn-primary"
            >Edit profile</button>
          </div>
        </CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-md-6">
              {this.renderUserDetail(current)}
            </div>
            <div className="col-md-6">
              {this.renderNotifySetting()}
            </div>
          </div>
          {this.renderMembership()}
        </CardBody>
        <CardFooter>
          <button className="btn btn-sm btn-default" onClick={() => this.props.history.goBack()}>
            <i className="fa fa-long-arrow-left"> </i> Go back
          </button>
        </CardFooter>
      </Card>
    }

    return (
      <div id="user-detail-page" className="animated fadeIn">
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Users/Detail.js